const participantTemplate = (data = {}) => ({
    id: data.id,
    displayName: data.displayName.trim() ? data.displayName : 'Unknown ' + data.id.substring(0, 4),
    availableUntil: data.availableUntil,
    avatar: data.avatar,
    title: data.title || 'User',
});

export default {
    // baseURL: 'http://localhost:8080/api/v1/',
    template: [],
    '/chat': {
        '/user': {
            '/me': {
                authorize: true,
                template: [
                    'CHAT_USER_TEMPLATE',
                    data => ({
                        id: data.id,
                        userId: data.userId,
                        displayName: data.displayName,
                        availableUntil: data.availableUntil,
                        signature: data.signature,
                    }),
                ],
                GET: {},
                PUT: {},
            },
        },
        '/conversation': {
            authorize: true,
            template: [
                'CONVERSATION_TEMPLATE',
                data => ({
                    id: data.id,
                    createdAt: data.createdAt,
                    open: data.open || false,
                    participants: data.participants.map(participantTemplate),
                }),
            ],
            GET: {},
            POST: {},
            '/:id': {
                template: [
                    'CONVERSATION_TEMPLATE_PUT',
                    data => ({
                        ...data,
                    }),
                ],
                PUT: {},
            },
        },
        '/availability': {
            '/id': {
                '/:org_id': {
                    template: ['ORG_AVAILABILITY_TEMPLATE', participantTemplate],
                    GET: {},
                },
            },
            '/summary': {
                template: [
                    'SUMMARY_AVAILABILITY_TEMPLATE',
                    data => ({
                        id: data.organizationId,
                        organizationId: data.organizationId,
                        count: data.count,
                    }),
                ],
                GET: {},
            },
        },
    },
};
